import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Tooltip } from "antd";

interface RowActionsProps {
	onEdit: () => void;
	onDelete: () => void;
	/** Confirmation copy shown in the delete popconfirm. */
	deleteTitle?: string;
	deleteDescription?: string;
	deleting?: boolean;
	/**
	 * Skips the hover-to-reveal behaviour. The default relies on `:hover`,
	 * which mobile card layouts have no real equivalent for — pass this there
	 * so the buttons stay visible without needing a hover state.
	 */
	alwaysVisible?: boolean;
}

/**
 * Edit/delete pair for table rows. Hidden until the row is hovered (see
 * `.row-actions` in index.css) so tables stay visually quiet.
 */
export function RowActions({
	onEdit,
	onDelete,
	deleteTitle = "O'chirilsinmi?",
	deleteDescription,
	deleting = false,
	alwaysVisible = false,
}: RowActionsProps) {
	return (
		<div className={`flex items-center justify-end gap-1 ${alwaysVisible ? "" : "row-actions"}`}>
			<Tooltip title="Tahrirlash">
				<Button
					type="text"
					size="small"
					aria-label="Tahrirlash"
					icon={<EditOutlined />}
					onClick={onEdit}
				/>
			</Tooltip>
			<Popconfirm
				title={deleteTitle}
				description={deleteDescription}
				okText="O'chirish"
				cancelText="Bekor qilish"
				okButtonProps={{ danger: true, loading: deleting }}
				onConfirm={onDelete}
			>
				<Tooltip title="O'chirish">
					<Button
						type="text"
						size="small"
						danger
						aria-label="O'chirish"
						icon={<DeleteOutlined />}
					/>
				</Tooltip>
			</Popconfirm>
		</div>
	);
}
